import axios from 'axios';
import Profile from "../../components/common/profile";
import store from '../../store';
import VueCookies from "vue-cookies";
import GlobalConstants from "../../components/common/global.constants";

// axios 인스턴스 생성
const commonAxois = axios.create({
    baseURL: '/',
    headers: {
        Accept: 'application/json',
        'Content-type': 'application/json;charset=utf-8',
    },
    timeout: 60000, // 요청 제한 시간 (60초)
});

commonAxois.interceptors.request.use(function(conf) {

    var config = conf;
    let tokenKey = Profile.env==='LOCAL' || Profile.env==='DEV' ? VueCookies.get(GlobalConstants.ACCESS_TOKEN_DEV) : VueCookies.get(GlobalConstants.ACCESS_TOKEN);

    const { excludeToken = false } = config;

    if(tokenKey && !excludeToken && tokenKey !== 'null') {
        config.headers.Authorization = `Bearer ${tokenKey}`;
    }
    else{
        console.log("no TWoken!~!");
    }
    return config;
}, function(err) {
    return Promise.reject(err);
});

commonAxois.interceptors.response.use((response) => {
    return response
}, function (error) {

    if (error.response.status === 401) {
        store.commit('user/SET_TOKEN_EXPIRATION', true);
        //logout(UrlsConfig.ssoUrl, false);
        // location.href = `${this.urls.ssoUrl}/logout?access_token=${tokenKey}&redirect_uri=${this.urls.tkUrl}`;
        console.log('unauthorized, logging out ...')
    }
    else if(error.response.status == '403') { // Smt login
        store.commit('user/SET_SMT_LOGIN', true);

    }
    // else {
    //     TODO : ADD afterRequestEvent
    // }

    return Promise.reject(error.response)

});

export default commonAxois;



// WEBPACK FOOTER //
// ./src/services/axios/common.axios.js